<template lang="html">
  <transition name="image-gallery-modal">
    <div class="image-gallery-modal-mask" id="image-gallery-modal-mask" tabindex="-1" @click="toggleOverlayElems">
      <div class="image-gallery-modal-wrapper">
        <button class="image-gallery-modal-close-button" @click="closeImageGalleryModal"></button>
        <div class="image-gallery-content-container">
          <img class="image-gallery-image" id="image-gallery-image" :src="currentItem.imageRef">
          <iframe id="image-gallery-caption" class="image-gallery-caption-html" :src="currentItem.captionRef" frameBorder="0" @load="captionLoaded"></iframe>
        </div>
        <div class="image-gallery-button-prev" @click="prevItem" v-show="showPrevNextButton"></div>
        <div class="image-gallery-button-next" @click="nextItem" v-show="showPrevNextButton"></div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  mapGetters
} from 'vuex'

export default {
  data() {
    return {
      items: [],
      itemIndex: 0
    }
  },
  created () {
    document.addEventListener('keydown', this.checkKey)
  },
  mounted() {
    let galModal = document.getElementById('image-gallery-modal-mask')
    if (this.showImageGalleryInArticle) {
      galModal.style.position = 'relative'
    }
    galModal.focus()
    this.createItems()
    if (this.isPhone() && this.showImageGalleryInArticle) {
      document.getElementsByClassName('image-gallery-modal-close-button')[0].style.top = '50px'
    }
  },
  computed: {
    currentItem() {
      if (this.items.length > 0) {
        return this.items[this.itemIndex]
      }
      return ''
    },
    showPrevNextButton () {
      return this.items.length > 1
    },
    showPrevButton () {
      return this.itemIndex > 0
    },
    showNextButton () {
      return this.itemIndex < this.items.length - 1
    },
    ...mapGetters({
      currentArticle: 'getCurrentArticle',
      showImageGalleryInArticle: 'getShowImageGalleryInArticle',
      articleFontsize: 'getArticleFontsize'
    })
  },
  watch: {
    articleFontsize: function (newValue) {
      this.updateFontSize(newValue)
    },
  },
  methods: {
    createItems() {
      for (var i = 0; i < this.currentArticle.children.length; i++) {
        let child = this.currentArticle.children[i]
        if (child.ImageReference !== '') {
          var item = {
            id: child.Uid,
            imageRef: '',
            captionRef: ''
          }
          item.imageRef = this.getEncodedResourceUrl(child.ImageReference)
          item.captionRef = this.getEncodedResourceUrl(child.CaptionReference)
          this.items.push(item)
        }
      }
    },
    captionLoaded() {
      this.updateFontSize(this.articleFontsize)
      this.showCaption()
    },
    closeImageGalleryModal(event) {
      if (event.target.className === 'image-gallery-modal-mask' || event.target.className === 'image-gallery-modal-close-button') {
        this.$store.commit('setShowImageGalleryModal', false)
        this.$store.commit('setShowImageGalleryInArticle', false)
      }
    },
    updateFontSize (fontSize) {
      var iframe = document.getElementById('image-gallery-caption')
      var inner = iframe.contentDocument || iframe.contentWindow.document
      var html = inner.getElementsByTagName('html')[0]
      html.style.fontSize = fontSize + this.$store.state.articleFontSizeUnit
      iframe.height = html.offsetHeight
      this.showCaption()
    },
    nextItem() {
      this.hideCaption()
      if (this.items.length > this.itemIndex + 1) {
        this.itemIndex++
      } else {
        this.itemIndex = 0
      }
    },
    prevItem() {
      this.hideCaption()
      if (this.itemIndex > 0) {
        this.itemIndex--
      } else {
        this.itemIndex = this.items.length - 1
      }
    },
    showCaption () {
      var iframe = document.getElementById('image-gallery-caption')
      iframe.style.visibility = 'visible'
    },
    hideCaption () {
      var iframe = document.getElementById('image-gallery-caption')
      iframe.style.visibility = 'hidden'
    },
    toggleOverlayElems (event) {
      if (event.target.className === 'image-gallery-modal-close-button') {
        return
      }
      var iframe = document.getElementById('image-gallery-caption')
      var prevBut = document.getElementsByClassName('image-gallery-button-prev')[0]
      var nextBut = document.getElementsByClassName('image-gallery-button-next')[0]
      if (iframe.style.visibility === 'hidden') {
        iframe.style.visibility = 'visible'
        prevBut.style.visibility = 'visible'
        nextBut.style.visibility = 'visible'
      } else {
        iframe.style.visibility = 'hidden'
        prevBut.style.visibility = 'hidden'
        nextBut.style.visibility = 'hidden'
      }
    },
    checkKey (e) {
      e = e || window.event
      if (e.key === "ArrowLeft") {
        this.prevItem()
      } else if (e.key === "ArrowRight") {
        this.nextItem()
      } else if (e.key === "Escape") {
        this.$store.commit('setShowImageGalleryModal', false)
        this.$store.commit('setShowImageGalleryInArticle', false)
      }
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.checkKey)
  }
}
</script>

<style lang=scss>
@import 'helpers/_colors-and-mixins.scss';
@import 'bourbon';

.image-gallery-modal-mask {
  position: fixed;
  z-index: 11000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity .3s ease;

  .image-gallery-modal-wrapper {
    max-width: 100%;
    position: relative;
    width: 100%;
    height: 100%;
    margin: auto;
    background: #1d1d1d;
    border-radius: 4px;

    .image-gallery-content-container {
      position: relative;
      display: flex;
      height: 100%;
      align-items: center;
      width: 100%;
      flex-shrink: 0;
      text-align: center;
      transition-property: transform;

      .image-gallery-image {
        max-height: 100%;
        max-width: 100%;
        user-select: none;
        pointer-events: auto !important;
        margin-left: auto;
        margin-right: auto;
        object-fit: contain;
        display: inline-block;
      }

      .image-gallery-caption-html {
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
        visibility: hidden;
      }
    }

    .image-gallery-modal-close-button {
      position: absolute;
      @include size(38px);
      cursor: pointer;
      right: 16px;
      top: 16px;
      border: 0;
      background: url("~assets/icons/overlay_close.svg");
      z-index: 10000;

      @include respond-to(phone) {
        right: 0px;
        position: fixed;
        padding: 0px;
        margin: 9px;
        top: 0px;
      }
    }

    .image-gallery-modal-close-button:focus {
      outline: none;
    }

    .image-gallery-modal-close-button:hover {
      background: url("~assets/icons/overlay_close_hover.svg");
    }

    .image-gallery-button-next {
      background: url("~assets/icons/overlay_next.svg");
      @include size(48px);
      position: absolute;
      top: 50%;
      right: 16px;
      transform: translate(0, -50%);
    }

    .image-gallery-button-next:hover {
      background: url("~assets/icons/overlay_next_hover_photo.svg");
    }

    .image-gallery-button-prev {
      background: url("~assets/icons/overlay_previous.svg");
      @include size(48px);
      position: absolute;
      top: 50%;
      left: 16px;
      transform: translate(0, -50%);
    }

    .image-gallery-button-prev:hover {
      background: url("~assets/icons/overlay_previous_hover_photo.svg");
    }
  }
}
</style>
